/**
 * Message descriptors: logic and view models never return translated text, only `{ key, params }`.
 * The UI resolves them with `useT()` (web), `L10n` (iOS/Android).

 */
import type { MessageKey } from "@bundle/i18n";

export type { MessageKey };
export type MessageParams = Record<string, string | number>;
export type MessageDescriptor = { key: MessageKey; params: MessageParams };

export function msg(key: MessageKey, params: MessageParams = {}): MessageDescriptor {
  return { key, params };
}

